import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { FilterProvider } from "@/context/FilterContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Executive from "@/pages/Executive";
import Operations from "@/pages/Operations";
import Inventory from "@/pages/Inventory";
import NestingRecords from "@/pages/NestingRecords";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, booting } = useAuth();
  if (booting || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "#0F172A" }}>
        <Loader2 className="animate-spin text-violet-400" size={32} />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/executive" element={<Protected><Executive /></Protected>} />
      <Route path="/operations" element={<Protected><Operations /></Protected>} />
      <Route path="/inventory" element={<Protected><Inventory /></Protected>} />
      <Route path="/records" element={<Protected><NestingRecords /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/executive" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <FilterProvider>
            <AppRoutes />
          </FilterProvider>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
